import * as _ from 'lodash';
import * as moment from 'moment';
import { useState, useEffect, FormEvent } from 'react';
import { Button, Col, FormControl, InputGroup, Row } from 'react-bootstrap';
import { Modal, ModalFooter } from 'react-bootstrap';
import DialysisDurationLabel from './dialysis-duration-label';

interface IProps {
    show: boolean,
    dialysisStartDate: string,
    onUpdateAndClose: (newDate: string) => void,
    onClose: () => void
}

const DialysisConfirmationModal = (props: IProps) => {
    const [dialysisDate, setDialysisDate] = useState(props.dialysisStartDate);

    useEffect(() => {
        setDialysisDate(props.dialysisStartDate);
    }, [props.dialysisStartDate]);

    const handleDialysisDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let isValid = moment(e.currentTarget.value, 'YYYY-MM-DD', true).isValid();

        if (isValid == false) {
            return;
        }

        setDialysisDate(e.currentTarget.value);
    };

    const handleUpdateAndClose = () => {
        props.onUpdateAndClose(dialysisDate);
    };

    return (
        <>
            <Modal backdrop='static' show={props.show} onHide={props.onClose}>
                <Modal.Header>
                    <Modal.Title>Dialysis Start Date</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Row>
                        <Col xs={12} lg={6}>
                            <InputGroup>
                                <FormControl
                                    type='date'
                                    value={dialysisDate}
                                    onChange={handleDialysisDateChange}
                                />
                                <DialysisDurationLabel dialysisStartDate={dialysisDate} />
                            </InputGroup>
                        </Col>
                    </Row>
                </Modal.Body>

                <ModalFooter>
                    <Button bsStyle='primary' onClick={handleUpdateAndClose}>Confirm and Save</Button>
                    <Button bsStyle='default' onClick={props.onClose}>Cancel</Button>
                </ModalFooter>
            </Modal>
        </>
    );
}


export default DialysisConfirmationModal;
